var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.sassStyles.root},[_c('span',{class:_vm.sassStyles.progressStep,attrs:{"data-cy":"wizzard-step-label"},domProps:{"innerHTML":_vm._s(_vm.stepLabel)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }